"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantityLabel = exports.Quantity = exports.Price = exports.Action = exports.Toppings = exports.Name = exports.CartItem = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CartItem = (0, _styledComponents["default"])(_slice.Flex)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  margin-bottom: 12px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  margin-bottom: 12px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])));
exports.CartItem = CartItem;
var Name = (0, _styledComponents["default"])(_slice.Text).attrs({
  as: 'h2'
})(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  line-height: 1.2;\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0;\n"], ["\n  line-height: 1.2;\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fonts.roboto;
});
exports.Name = Name;
var Toppings = (0, _styledComponents["default"])(_slice.Text).attrs({
  fontSize: '14px',
  my: 1
})(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  color: ", ";\n  line-height: 1.2;\n"], ["\n  color: ", ";\n  line-height: 1.2;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.grey500;
});
exports.Toppings = Toppings;
var Action = (0, _styledComponents["default"])(_slice.Anchor)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  text-transform: uppercase;\n  color: ", ";\n  line-height: 1;\n  font-size: 16px;\n  text-decoration: underline;\n"], ["\n  text-transform: uppercase;\n  color: ", ";\n  line-height: 1;\n  font-size: 16px;\n  text-decoration: underline;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.black;
});
exports.Action = Action;
var Price = (0, _styledComponents["default"])(_slice.Text).attrs({
  fontSize: 4
})(templateObject_5 || (templateObject_5 = (0, _tslib.__makeTemplateObject)(["\n  text-align: right;\n"], ["\n  text-align: right;\n"])));
exports.Price = Price;
var Quantity = (0, _styledComponents["default"])(_slice.Input).attrs({
  inputmode: 'numeric',
  pattern: '[0-9]*'
})(templateObject_6 || (templateObject_6 = (0, _tslib.__makeTemplateObject)(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
exports.Quantity = Quantity;
var QuantityLabel = (0, _styledComponents["default"])(_slice.Label)(templateObject_7 || (templateObject_7 = (0, _tslib.__makeTemplateObject)(["\n  text-transform: uppercase;\n"], ["\n  text-transform: uppercase;\n"])));
exports.QuantityLabel = QuantityLabel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;